import {
  FETCH_WITHDRAWS,
  FETCH_WITHDRAWS_SUCCESS,
  FETCH_WITHDRAWS_FAILED,
  EDIT_WITHDRAWS
} from "../store/types";
import { firebase } from '../config/configureFirebase';
import { onValue, child, update, once, get } from "firebase/database";

export const fetchWithdraws = () => async (dispatch) => {
  const { withdrawRef, bankUserDetailsRef } = firebase;

  dispatch({
    type: FETCH_WITHDRAWS,
    payload: null
  });

  try {
    // Fetch withdraws dan bank details secara parallel
    const [withdrawSnapshot, bankSnapshot] = await Promise.all([
      get(withdrawRef),
      get(bankUserDetailsRef)
    ]);

    if (withdrawSnapshot.val()) {
      const withdrawData = withdrawSnapshot.val();
      const bankData = bankSnapshot.val() || {};
      
      // Enrich withdraw data dengan bank details
      const enrichedWithdraws = Object.keys(withdrawData).map(i => {
        const withdraw = withdrawData[i];
        const userId = withdraw.uid || withdraw.requestedBy;
        
        // Find bank details for this user
        let userBankData = null;
        for (const bankKey in bankData) {
          if (bankData[bankKey] && bankData[bankKey].userId === userId) {
            userBankData = bankData[bankKey];
            break;
          }
        }
        
        return {
          ...withdraw,
          id: i,
          bankData: userBankData // Attach bank data langsung
        };
      });

      dispatch({
        type: FETCH_WITHDRAWS_SUCCESS,
        payload: enrichedWithdraws.reverse()
      });
    } else {
      dispatch({
        type: FETCH_WITHDRAWS_FAILED,
        payload: "No WITHDRAWS available."
      });
    }
  } catch (error) {
    console.error('Error fetching withdraws:', error);
    dispatch({
      type: FETCH_WITHDRAWS_FAILED,
      payload: error.message
    });
  }
};

export const completeWithdraw = (entry, success) => (dispatch) => {

  const {
    withdrawRef
  } = firebase;
  
  dispatch({
    type: EDIT_WITHDRAWS,
    payload: entry
  });
  if(success){
    update(child(withdrawRef, entry.id),{ ...entry, processed: true, processDate: new Date().getTime() });
  } else{
    update(child(withdrawRef, entry.id),{ ...entry, error: entry.error });
  }
}

// New action to process withdraw using Firebase function
export const processWithdraw = (withdrawId, action, adminData, rejectReason = null) => async (dispatch) => {
  const { config } = firebase;
  try {
    // Call the HTTP Firebase function
    const response = await fetch(`https://us-central1-${config.projectId}.cloudfunctions.net/processWithdrawHttp`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Origin': window.location.origin
      },
      body: JSON.stringify({
        withdrawId,
        action, // 'approve' or 'reject'
        adminId: adminData.id || adminData.uid,
        adminName: adminData.name || adminData.firstName + ' ' + adminData.lastName,
        rejectReason
      })
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Unknown error' }));
      throw new Error(errorData.error || `HTTP ${response.status}: ${response.statusText}`);
    }

    const result = await response.json();
    
    if (result.success) {
      // Refresh withdraws data
      dispatch(fetchWithdraws());
      return { 
        success: true, 
        message: result.message,
        newBalance: result.newBalance // Include new balance if available
      };
    } else {
      throw new Error(result.error || 'Failed to process withdraw');
    }
    
  } catch (error) {
    console.error('Error calling processWithdraw HTTP function:', error);
    
    // Enhanced error handling
    if (error.message && error.message.includes('CORS')) {
      throw new Error('Network error: CORS policy blocked the request.');
    } else if (error.message && error.message.includes('Failed to fetch')) {
      throw new Error('Network error: Unable to connect to server.');
    } else if (error.message && error.message.includes('HTTP 401')) {
      throw new Error('Unauthorized. Please check your authentication.');
    } else if (error.message && error.message.includes('HTTP 403')) {
      throw new Error('Forbidden. You do not have permission to perform this action.');
    } else if (error.message && error.message.includes('HTTP 404')) {
      throw new Error('Withdraw request not found.');
    } else if (error.message && error.message.includes('HTTP 400')) {
      throw new Error('Bad request. Please check your input data.');
    } else if (error.message && error.message.includes('HTTP 500')) {
      throw new Error('Server error. Please try again later.');
    }
    
    throw error;
  }
};